// @module NXTurn.ShoppingExtensions.PDP
define('C3.ShoppingExtensions.PDP.AddToWishlist.Rightside.View'
,   [
        'c3_addtowishlist_rightside.tpl',
        'Profile.Model',
       // 'SC.Configuration',
        'Utils',
        'Header.Menu.MyAccount.View',
        'Header.Menu.View',
        'Product.Model',
        'C3.ShoppingExtensions.PDP.AddToWishlist.Rightside.ListControl.View'
    ]
, function (
        c3_addtowishlist_rightside_tpl,
        ProfileModel,
        //Configuration,
        Utils,
        HeaderMenuMyAccountView,
        HeaderMenuView,
        ProductModel,
        ProductListControlView
)
{
    'use strict';

    // @class NXTurn.ShoppingExtensions.PDP.View @extends Backbone.View
    return Backbone.View.extend({

        template: c3_addtowishlist_rightside_tpl

    ,   initialize: function (options) {
            //console.log(options)
            this.application = this.options.application;

            //this.parentView = options.parentView;

            //console.log(this.parentView)

            this.utils =
                this.application.ProductListModule && this.application.ProductListModule.Utils;

            this.model = new ProductModel({
                internalid: options.item.internalid,
                quantity: 1,
                item : options.item
            });    

            this.countedClicks = {};

            const self = this;

            this.first_time_render = true;

            ProfileModel.getPromise().done(function() {
                self.loaded_site_settings = true;
                self.render();
            });
        }


    , render: function() {
        if (this.loaded_site_settings && this.utils && this.utils.isProductListEnabled()) {
            if (this.first_time_render) {
                this.utils.getProductListsPromise().done(_.bind(this.render, this));
                this.first_time_render = false;
                return this.$el.empty();
            }
        } else {
            return this.$el.empty();
        }

        this._render();
    }     

    ,   events: {

        }

    ,   bindings: {
        }

    ,   childViews: {
            'Wishlish.Items.List': function() {
                return new ProductListControlView({
                    collection: this.utils.getProductLists(),
                    product: this.model,
                    application: this.application,
                    countedClicks: this.countedClicks,
                   // parentView : this.parentView
                });
              }
        }


        //@method getContext @return NXTurn.ShoppingExtensions.PDP.View.Context
    ,   getContext: function getContext()
        {
            
            return {
              isLoading: this.utils.getProductListsPromise().state() === 'pending'   
            };
        }
    });
});
